export const messages = {
    nb: {
        toastGetDebitorsFailed: 'Henting av debitorer for valgt kreditor feilet. ',
        toastGetDebitorsOk: 'Hentet debitorer for valgt kreditor',
    }
}